module.exports = __webpack_public_path__ + "static/media/comming_soon.4f042ae2.svg";